export default defineNuxtPlugin(() => {
  /**
   * Custom service worker registration for PWA scope restriction.
   *
   * This plugin ensures the service worker is only registered on /dashboard routes.
   *
   * Why:
   * - By default, Nuxt/Vite PWA registers the service worker globally, which can cause caching and Workbox logs on all routes.
   * - We only want PWA features and caching within the /dashboard section of the app.
   * - This plugin disables global registration and manually registers the service worker only when the user is on a /dashboard route.
   * - This prevents unwanted caching and service worker activity outside the PWA scope.
   */
  if (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    window.location.pathname.startsWith('/dashboard') &&
    !import.meta.dev // Only register in production
  ) {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/dashboard/' })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error('Service worker registration failed:', err)
      })
  }
})
